import React,{useState, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import './auth.css';
import axios from '../axios';
import {GoogleLogin} from 'react-google-login';
import {faArrowLeft} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'


function Auth({authenticate}) {

   const [isError, setIsError] = useState(false);


    const onClick = () => {
        authenticate();
    } 
useEffect(()=>{
})    

 const responseGoogleSuccess = (response) => {

      console.log(response.profileObj)
      if(response.profileObj.email === 'sans69055@gmail.com'){
        authenticate()
        window.open("/admin/profile","_self")
      }
      else {
          setIsError(true);
          setTimeout(()=>{
               setIsError(false)
          },5000)
      }

}

const responseGoogleFailure = (response) =>{ 
       setIsError(true);
       setTimeout(() => {
           setIsError(false)
       }, 4000);
       
       console.log(response)

} 
  return (
    <div>
        <div className='admin_login_container container\'>
            <h2 className='text-center auth_heading'>SPS LAND PROMOTERS</h2>
        <FontAwesomeIcon 
        icon={faArrowLeft} 
        onClick={()=> window.open("/","_self")}
        className="arrow_left_admin"/> <span style={{fontSize:'1.2rem', fontWeight:'bold', color:'darkgray'}}>Back to Home </span>
        <h4 className='text-center auth_heading'>Login here</h4>
        <div
    className="google_login"
    >
            <GoogleLogin
    clientId="533622855377-olmenas5unav4ali83lkdj31bbnfvltu.apps.googleusercontent.com"
    buttonText="Login Only Admin"
    onSuccess={responseGoogleSuccess}
    onFailure={responseGoogleFailure}
    cookiePolicy={'single_host_origin'}
    />
    </div>
    <h6 style={{color:'red', marginTop:'30px'}} className="text-center">{isError ? "something went wrong please try again...": ""}</h6>
        </div>
    </div>
  )
}

export default Auth